
import { Vue, Component, Prop } from "vue-property-decorator";
import vModal from "@/components/vModal.vue";
import { mapState } from "vuex";

@Component({
  components: {
    vModal,
  },
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule
    }),
  },
})
export default class vGrandfatheredSubscriptionWarningModal extends Vue {
  @Prop() showWarningModal!: boolean;
  @Prop() isCancellation!: boolean;
  @Prop() isLegacySubscription!: boolean;
  @Prop({ default: false }) isFutureSubscription!: boolean;

  localizationState: any;

  get translations() {
    return this.localizationState.translations;
  }

  get modalTitleTranslationKey() {
    return this.isCancellation
      ? "ms_modal_cancel_title"
      : "ms_modal_change_title";
  }

  get modalBoldActionTranslationKey() {
    return this.isCancellation
      ? "ms_modal_braintree_cancel_subscription"
      : "ms_modal_braintree_change_subscription";
  }

  get modalBoldActionDescriptionTranslationKey() {
    return this.isCancellation
      ? "ms_modal_braintree_cancel_subscription_msg"
      : "ms_modal_braintree_change_subscription_msg";
  }

  get modalMessageTranslationKey() {
    return this.isCancellation
      ? "ms_subscription_notification_for_current_braintree_users"
      : "ms_subscription_change_notification_for_grandfathered_pricing_users";
  }

  closeWarningModal() {
    this.$emit("on-cancel");
    this.showWarningModal = false;
  }
}
